import { ButtonIcon } from '@nab/nui-react';
import styled from 'styled-components';

export const ButtonContainer = styled.div`
    background: #ed0000;
    width: 3rem;
    height: 100%;
`;

export const CustomButton = styled(ButtonIcon)`
    width: 100%;
    height: 100%;
    margin: auto;
`;
